import * as React from 'react';
import { Slider as AntdSlider } from 'antd';
import { SliderSingleProps as AntdSliderProps } from 'antd/lib/slider';
import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface SliderProps extends AntdSliderProps {
  className?: string;
}

const Slider: React.FC<SliderProps> = (props) => {
  const { className } = props;
  const { prefixCls } = React.useContext(AppContext);

  return (
    <AntdSlider
      {...props}
      className={classnames(`${prefixCls}-slider`, className, {
        [`${prefixCls}-slider-mobile`]: isMobile,
      })}
    />
  );
};

export default Slider;
